import React from 'react';
import { useScheduleContext } from './context/ScheduleContext';

export type SchedulePanelContextValue = {
  scheduleId: number | string | null;
  isActive: boolean;
};

const SchedulePanelContext = React.createContext<SchedulePanelContextValue | null>(null);

export function SchedulePanelProvider({
  scheduleId,
  children,
}: {
  scheduleId: number | string | null;
  children: React.ReactNode;
}) {
  const currentScheduleId = useScheduleContext().currentScheduleId;
  const value = React.useMemo<SchedulePanelContextValue>(
    () => ({
      scheduleId,
      isActive: currentScheduleId != null && currentScheduleId === scheduleId,
    }),
    [scheduleId, currentScheduleId]
  );
  return (
    <SchedulePanelContext.Provider value={value}>
      {children}
    </SchedulePanelContext.Provider>
  );
}

export function useSchedulePanelContext(): SchedulePanelContextValue | null {
  return React.useContext(SchedulePanelContext);
}
